import React, { useState, useMemo, useEffect } from 'react';
import * as Yup from 'yup';
import {
    CrudMasterDetailView,
    GridView,
    Widget,
    FormInput,
    FormSubmitButton,
    FormSelect,
    CompositeView,
    MasterDetailForm,
    FormatText,
    FormTextArea,
    ButtonDelete,
    CrudContext,
    useRouter,
} from '@digital/ui';
import { hasPermission } from '../../helpers/permissions';
import { getAllPerfil, getAllPerfilComModulo } from '@app/api/PerfilAcesso';
import TabelaPermissaoPerfil from './tabelaPermissaoPerfil';
import { CreatModuloPerfil, CreatPerfil, postPerfil, putPerfil } from '@app/api/moduloPerfilPermissao';
import { GuidEmpty } from '@app/helpers/generatorGuid';


const PerfilAcesso = () => {

    const [listPerfilAcesso, setPerfilAcesso] = useState(() => getAllPerfilComModulo);
    const [resultModulo, setResultModulo] = useState()
    const { history } = useRouter();

    const onCreatPerfil = async (values: CreatPerfil) => {
        const result = await postPerfil(values);
        if (result) {
            listaPerfil();
            return Promise.resolve(undefined);
        }
        return Promise.resolve(undefined);
    }

    const onUpdatePerfil = async (values: CreatModuloPerfil) => {
        const result = await putPerfil(values);
        if (result) {
            listaPerfil();
        }
        return Promise.resolve(true);;
    }

    const validationSchema = Yup.object().shape({
        nome: Yup.string().required('Nome deve ser informada'),
    });

    const listaPerfil = () => {
        setPerfilAcesso(() => Promise.resolve(undefined));
        setPerfilAcesso(() => getAllPerfilComModulo);
    };

    return (
        <CrudMasterDetailView
            getAllItems={listPerfilAcesso}
            createItem={onCreatPerfil}
            updateItem={onUpdatePerfil}
            disableNotification
            icon="business-flow_chart"
            detailTitleExtractor={x => `${x.nome} - ${x.descricao}`}
            filterPredicate={(item, value) =>
                item.nome.toLowerCase().includes(value.toLowerCase())
            }
            titleExtractor={item => item.nome}
            descriptionExtractor={item => item.nome || `--- - ${item.descricao}`}>
            <CompositeView>
                {true && (
                    <CrudContext.Consumer>
                        {({ selectedItem }) => {
                            return (
                                <GridView noform>
                                    <MasterDetailForm
                                        validationSchema={validationSchema}>
                                        <Widget
                                            actions={[
                                                true && (
                                                    <FormSubmitButton type="primary">
                                                        <FormatText id="ui.commons.save" uppercase />
                                                    </FormSubmitButton>
                                                ),
                                            ]}>
                                            <FormInput label="Nome" name="nome" span={6} />
                                            <FormTextArea label="Descrição" name="descricao" rows={3} />
                                        </Widget>

                                        {selectedItem && selectedItem.id != GuidEmpty ?
                                            (
                                                <>
                                                    <Widget actions={[]}>
                                                        <TabelaPermissaoPerfil
                                                            nomesColunas={selectedItem.nomeColunas}
                                                            perfilId={selectedItem.id}
                                                        />
                                                    </Widget>
                                                </>
                                            )
                                            :
                                            (
                                                <> </>
                                            )
                                        }

                                    </MasterDetailForm>
                                </GridView>
                            );
                        }}
                    </CrudContext.Consumer>
                )}
            </CompositeView>
        </CrudMasterDetailView >
    )

}

export default PerfilAcesso;